import styled from 'styled-components';
import { getColor } from '@karma/components/colors';

export const StyledTitle = styled.div`
  display: inline-block;
  width: 100%;
  color: ${getColor('primary1')};
  font-size: 16px;
  font-weight: 400;
  margin-left: 15px;
`;
export const StyledSubtitle = styled.span`
  font-style: italic;
`;
